import { render, staticRenderFns } from "./Upload2.vue?vue&type=template&id=dd2c8c58&"
import script from "./Upload2.vue?vue&type=script&lang=js&"
export * from "./Upload2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports